import { render, staticRenderFns } from "./InputSearchOwner.vue?vue&type=template&id=4fb83488&scoped=true"
import script from "./InputSearchOwner.vue?vue&type=script&lang=js"
export * from "./InputSearchOwner.vue?vue&type=script&lang=js"
import style0 from "./InputSearchOwner.vue?vue&type=style&index=0&id=4fb83488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb83488",
  null
  
)

export default component.exports